<!-- Header section following F8916 pattern -->
<div class="modal-header">
  <h3 class="modal-title">{{ modalTitle }}</h3>
  <div class="header-actions">
    <i class="fa" 
       [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}" 
       style="margin-right: 10px; cursor: pointer;" 
       (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<!-- Body with tabs following F8916 pattern -->
<div class="modal-body" [hidden]="minimise">
  <ul class="nav nav-pills" role="tablist">
    @for (tab of tabs; track $index) {
<li [class.active]="tab.id === activeTab">
      <a (click)="activeTab = tab.id; assignTabNames(tab.name)" style="cursor: pointer;" class="btn-sm">
        {{ tab.name }}
      </a>
    </li>
}
  </ul>

  <div class="tab-content">
    <!-- Form Entry Tab -->
    @if (activeTab === 1) {
<div class="tab-pane active" style="overflow-y: auto; max-height: calc(90vh - 200px);">
      <div class="form-horizontal">
        @if (showFormLoader) {
<div class="formLoader">
          <i class="fa fa-spinner fa-spin gt-refresh"></i>
        </div>
}
        
        @if (!showFormLoader) {
<div>
          <!-- Entity information table -->
          <table class="table table-bordered form-inline enityDetails">
            <tr>
              @for (item of entityList; track $index) {
<td>
                <span>{{ item.key }}</span>
              </td>
}
            </tr>
            <tr>
              @for (item of entityList; track $index) {
<td>
                <span>{{ item.value }}</span>
              </td>
}
            </tr>
          </table>
          
          <!-- Main Form Table -->
          <table class="table table-bordered form-inline custom-table">
            <thead>
              <tr>
                <th id="F7004_LINENO_CRUD_1" class="sticky-col">{{ tableHeader[0]?.LINE_NO }}</th>
                <th id="F7004_DESC_CRUD_2" class="sticky-col">{{ tableHeader[0]?.DESCRIPTION }}</th>
                @for (val of tableHeader; track $index; let i = $index) {
<th 
                    [id]="'F7004_HEADER_CRUD_' + i" class="sticky-col">
                  {{ val.ATTRIB_DESCRIPTION }}
                </th>
}
              </tr>
            </thead>
            <tbody>
              @for (row of f7004FormView; track itemTracker(i, row); let i = $index) {
<tr class="formDataBlock" 
                 
                  [style.display]="filterFormDisplay(row) ? '' : 'none'">
                
                <!-- Line number display -->
                @if (row.ROW_TYPE != 'PH') {
<td>{{ row.LINE_DISP }}</td>
}
                @if (row.ROW_TYPE == 'PH') {
<td style="font-size: 14px;" 
                    [ngClass]="{'color-red': row.ROW_TYPE == 'PH'}">
                  <b>{{ row.LINE_DISP }}</b>
                </td>
}
                
                <!-- Description column -->
                @if (row.ROW_TYPE == 'PH') {
<td style="font-size: 14px;" 
                    [ngClass]="{'color-red': row.ROW_TYPE == 'PH'}">
                  <span><b>{{ row.DESCRIPTION }}</b></span>
                </td>
}
                @if (row.ROW_TYPE == 'DT') {
<td>{{ row.DESCRIPTION }}</td>
}
                @if (row.ROW_TYPE == 'CT') {
<td>
                  @if (row.EDIT_TYPE == 'checkbox') {
<div style="padding-left: 25px">
                    <input type="checkbox" 
                           [checked]="row.ATTRIB_VALUE === 'true'"
                           (change)="onCheckboxChange($event, row, i)">
                    {{ row.ATTRIB_DESCRIPTION }}
                    @if (row.LINE_NO == '5b(v)' && row.ATTRIB_SHORT_CODE == 'F7004_LINE_5b_CHECK5') {
<input style="width: 400px !important;" type="text" 
                           [disabled]="conditionalField" 
                           [(ngModel)]="row.value_user_input" 
                           [name]="row.LINE_NO"
                           
                           class="form-control input-sm" 
                           (ngModelChange)="validateSubForm(f7004FormView, row, i)">
}
                  </div>
}
                </td>
}
                
                <!-- Input column -->
                <td align="center">
                  <!-- Number input -->
                  @if (row.DATA_TYPE == 'number' && row.IS_EDITABLE_CELL == 'Y') {
<div>
                    <input type="number" 
                           [disabled]="row.conditionalField" 
                           [(ngModel)]="row.ATTRIB_VALUE" 
                           [name]="row.num"
                           min="0"
                           (ngModelChange)="validateSubForm(f7004FormView, row, i)" 
                           class="form-control input-sm">
                  </div>
}

                  <!-- Non-editable number display -->
                  @if (row.IS_EDITABLE_CELL == 'N' && row.DATA_TYPE == 'number') {
<div style="text-align: right; padding-right: 10px" 
                       
                       [ngClass]="{'color-red': row.ATTRIB_VALUE < 0}">
                    <span [id]="'F7004NOTEDITABLE_CRUD_' + (i + 1)">{{ row.ATTRIB_VALUE | number }}</span>
                  </div>
}
                  
                  <!-- String input -->
                  @if (row.DATA_TYPE == 'string' && row.EDIT_TYPE == 'text' && row.IS_EDITABLE_CELL == 'Y' && row.LINE_NO != '5b') {
<div>
                    <input [id]="'F7004STRING123_CRUD_' + (i + 1)" 
                           class="form-control input-md numText" 
                           style="text-align: right" 
                           type="text" 
                           [(ngModel)]="row.ATTRIB_VALUE" 
                           [disabled]="row.is_editable" 
                           placeholder="" 
                           aria-describedby="basic-addon2" 
                           (ngModelChange)="checkYr(row, i)">
                  </div>
}
                  
                  <!-- Checkbox input -->
                  @if (row.ROW_TYPE != 'CT' && row.EDIT_TYPE == 'checkbox') {
<div>
                    <input [id]="'F7004CHECKBOX_CRUD_' + (i + 1)" 
                           type="checkbox" 
                           [checked]="row.ATTRIB_VALUE === 'true'"
                           (change)="onCheckboxChange($event, row, i)">
                  </div>
}
                  
                  <!-- Dropdown -->

                  @if (row.EDIT_TYPE == 'dropdown') {
<div>
                    <select [id]="'F7004DROPDOWN_CRUD_' + (i + 1)" 
                            style="width: 200px" 
                            class="form-control" 
                            [name]="'f7004_dropdown_' + i" 
                            [compareWith]="dropdownOptionCompareWith"
                            (ngModelChange)="onDropDownChange($event, row, i)" 
                            [(ngModel)]="row.ATTRIB_VALUE">
                      <option value="">Select</option>
                      @for (option of formLOV; track $index) {
<option [value]="option.CODE_NAME">
                        {{ option.CODE_DESC }}
                      </option>
}
                    </select>
                  </div>
}
                  
                  <!-- Date picker -->
                  @if (row.EDIT_TYPE == 'custom_date_various') {
<div class="input-group">
                    <input type="date" 
                           class="form-control" 
                           [(ngModel)]="row.ATTRIB_VALUE"
                           [disabled]="row.conditionalField"
                           (ngModelChange)="formatDate(row)">
                  </div>
}
                </td>
              </tr>
}
            </tbody>
          </table>
          
          <!-- IRS Payment Section -->
          <table style="table-layout: fixed;" class="table table-bordered form-inline custom-table"> 
            <thead>
              <th class="heading sticky-col" style="text-align: center !important">IRS Payment</th>
            </thead>
            <tbody> 
              <tr>
                <td>
                  <div class="col-md-12">
                    <div class="col-md-3 bold-font noWrap">
                      <span>Routing Transit Num :</span>
                      <i class="fa fa-info-circle" title="Routing Transit Number - 9 digits beginning with 01 through 12, or 21 through 32"></i>
                    </div>
                    <div class="col-md-2 centerText">
                      <input type="text" 
                             class="form-control" 
                             name="F7004_ROUTING_NUM" 
                             maxlength="9"
                             (ngModelChange)="assignIRSPaymentValues('F7004_ROUTING_NUM', $event)" 
                             [(ngModel)]="routingTransNum" 
                             onlyDigits
                             aria-describedby="basic-addon1">
                    </div>
                  </div>
                </td>
              </tr>
              
              <tr>
                <td>
                  <div class="col-md-12" style="padding-top: 10px;">
                    <div class="col-md-3 bold-font noWrap">
                      <span>Bank Account Num :</span>
                      <i class="fa fa-info-circle" title="Bank Account Number - 17 alphanumeric characters with hyphens"></i>
                    </div>
                    <div class="col-md-2 centerText">
                      <input type="text" 
                             class="form-control" 
                             name="F7004_ACCOUNT_NUM" 
                             [(ngModel)]="bankAccountNum" 
                             maxlength="17" 
                             aria-describedby="basic-addon1" 
                             (focus)="getViewdetails(bankAccountNum)" 
                             (blur)="getdetails(bankAccountNum)" 
                             (ngModelChange)="assignIRSPaymentValues('F7004_ACCOUNT_NUM', bankAccountNum)">
                    </div>
                  </div>
                </td>
              </tr>
              
              <tr>
                <td>
                  <div class="col-md-12" style="padding-top: 10px;">
                    <div class="col-md-3 bold-font noWrap">
                      <span>Bank Account Type Cd :</span>
                      <i class="fa fa-info-circle" title="Bank Account Type (1 for Checking, 2 for Savings)"></i>
                    </div>
                    <div class="col-md-2 centerText">
                      <select id="bankAcctTypeCD" 
                              style="width: 236px" 
                              class="form-control" 
                              name="F7004_ACCOUNT_TYPE" 
                              (ngModelChange)="assignIRSPaymentValues('F7004_ACCOUNT_TYPE', bankAccountType)" 
                              [(ngModel)]="bankAccountType">
                        <option value="">Select</option>
                        @for (option of bankAcctTypeOptions | keyvalue; track option.key) {
<option 
                                [value]="option.value.CODE_NAME">
                          {{ option.value.CODE_DESC }}
                        </option>
}
                      </select>
                    </div>
                  </div>
                </td>
              </tr>
              
              <tr>
                <td>
                  <div class="col-md-12" style="padding-top: 10px;">
                    <div class="col-md-3 bold-font noWrap">
                      <span>Payment Amount :</span>
                      <i class="fa fa-info-circle" title="PositiveInteger"></i>
                    </div>
                    <div class="col-md-2 centerText">
                      <input type="text" 
                             class="form-control" 
                             name="F7004_AMOUNT" 
                             [(ngModel)]="paymentType" 
                             validNumber
                             allowNegative="false"
                             allowDecimal="false"
                             aria-describedby="basic-addon1" 
                             (ngModelChange)="assignIRSPaymentValues('F7004_AMOUNT', paymentType)">
                    </div>
                  </div>
                </td>
              </tr>
              
              <tr>
                <td>
                  <div class="col-md-12" style="padding-top: 10px;">
                    <div class="col-md-3 bold-font noWrap">
                      <span>Requested Payment Date :</span>
                      <i class="fa fa-info-circle" title="MM/dd/yyyy"></i>
                    </div>
                    <div class="input-group" style="padding-left: 14px; width: 253px !important;">
                      <input type="date" 
                             class="form-control" 
                             [(ngModel)]="paymentDate" 
                             name="F7004_PAYMENT_DATE" 
                             (ngModelChange)="assignIRSPaymentValues('F7004_PAYMENT_DATE', paymentDate)">
                    </div>
                  </div>
                </td>
              </tr>
              
              <tr>
                <td>
                  <div class="col-md-12" style="padding-top: 10px;">
                    <div class="col-md-3 bold-font noWrap">
                      <span>Taxpayer DayTime Phone Number :</span>
                      <i class="fa fa-info-circle" title="Used for a phone no. - 10 digits"></i>
                    </div>
                    <div class="col-md-2 centerText">
                      <input type="text" 
                             class="form-control" 
                             name="F7004_PHONE_NUMBER"
                             [value]="phoneNumber" 
                             maxlength="14"
                             (input)="onPhoneInput($event)"
                             (keydown)="onPhoneKeydown($event)"
                             (focus)="onPhoneFocus($event)"
                             (click)="onPhoneClick($event)"
                             aria-describedby="basic-addon1">
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
}
      </div>
    </div>
}
    
    <!-- Subsidiary Tab -->
    @if (activeTab === 2) {
<div class="tab-pane active">
      <table style="table-layout: fixed;" class="table table-bordered form-inline custom-table">
        <thead>
          <tr>
            <th class="heading sticky-col">LEID</th>
            <th class="heading sticky-col">Tax Code</th>
            <th class="heading sticky-col">LE Name</th>
            <th class="heading sticky-col">Address</th>
            <th class="heading sticky-col">Employer-ID</th>
            <th class="heading sticky-col">Tax Period</th>
          </tr>
        </thead>
        <tbody>
          @for (row of subsidiaries; track itemTracker($index, row)) {
<tr>
            <td style="vertical-align: top">{{ row.LEID }}</td>
            <td style="vertical-align: top">{{ row.CDR_NO }}</td>
            <td style="vertical-align: top">{{ row.LE_NAME }}</td>
            <td style="vertical-align: top">{{ row.ADDRESS }}</td>
            <td style="vertical-align: top">{{ row.EIN }}</td>
            <td style="vertical-align: top">{{ row.taxYearEnd }}</td>
          </tr>
}
        </tbody>
      </table>
    </div>
}
  </div>
</div>

<!-- Footer buttons following F8916 pattern (Save/Reset only on Form Entry tab) -->
<div class="modal-footer" [hidden]="minimise">
  @if (currentTabName != 'Subsidiary') {
<button 
          class="save-button" 
          type="button" 
          [disabled]="isSaveClicked" 
          (click)="save()">
    @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}Save and Proceed
  </button>
}
  @if (currentTabName != 'Subsidiary') {
<button 
          class="reset-button" 
          type="button" 
          (click)="reset()">Reset</button>
}
  <button class="cancel-button" 
          type="button" 
          (click)="cancel()">Cancel</button>
</div> 
